"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageDataTable = void 0;

var _styles = require("./styles");

var _TableHeader = require("../../molecules/TableHeader");

var _styles2 = require("../../molecules/TableRow/styles");

var _ScreenHeader = require("../../atoms/ScreenHeader");

var _LabelToInput = _interopRequireDefault(require("../../atoms/LabelToInput"));

var _jsxRuntime = require("react/jsx-runtime");

var ImageDataTable = function ImageDataTable(_ref) {
  var _lists$inputs, _lists$inputs$find, _lists$imagePackaging, _lists$imagePackaging2, _lists$imageType, _lists$imageType$find, _lists$imageShotType, _lists$imageShotType$, _lists$attrForImgs, _lists$attrForImgs$ge;

  var activeImage = _ref.activeImage,
      darkMode = _ref.darkMode,
      lists = _ref.lists,
      retailerSelected = _ref.retailerSelected,
      setImages = _ref.setImages,
      assignationsImages = _ref.assignationsImages,
      imagesStatus = _ref.imagesStatus,
      setAssignation = _ref.setAssignation,
      isRetailer = _ref.isRetailer,
      onClickSave = _ref.onClickSave,
      showSaveButton = _ref.showSaveButton,
      version = _ref.version,
      setShowVersionSelector = _ref.setShowVersionSelector,
      shotThd = _ref.shotThd;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    darkMode: darkMode,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableHeader.TableHeader, {
      imagesStatus: imagesStatus,
      activeImage: activeImage,
      assignationsImages: assignationsImages,
      setAssignation: setAssignation,
      isRetailer: isRetailer,
      showSaveButton: showSaveButton,
      onClickSave: onClickSave,
      version: version,
      setShowVersionSelector: setShowVersionSelector
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles2.Container, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
        headerType: "table-row-text",
        text: "Tipo de toma"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
        headerType: "table-row-text gray-table-row",
        text: (lists === null || lists === void 0 ? void 0 : (_lists$inputs = lists.inputs) === null || _lists$inputs === void 0 ? void 0 : (_lists$inputs$find = _lists$inputs.find(function (f) {
          return f.id === +(activeImage === null || activeImage === void 0 ? void 0 : activeImage.image_id);
        })) === null || _lists$inputs$find === void 0 ? void 0 : _lists$inputs$find.name) || "-"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles2.Container, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
        headerType: "table-row-text",
        text: "Tipo de empaque"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
        headerType: "table-row-text gray-table-row",
        text: (lists === null || lists === void 0 ? void 0 : (_lists$imagePackaging = lists.imagePackagingType) === null || _lists$imagePackaging === void 0 ? void 0 : (_lists$imagePackaging2 = _lists$imagePackaging.find(function (f) {
          return f.id === +(activeImage === null || activeImage === void 0 ? void 0 : activeImage.packing_type);
        })) === null || _lists$imagePackaging2 === void 0 ? void 0 : _lists$imagePackaging2.name) || "-"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles2.Container, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
        headerType: "table-row-text",
        text: "Tipo de imagen"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
        headerType: "table-row-text gray-table-row",
        text: (lists === null || lists === void 0 ? void 0 : (_lists$imageType = lists.imageType) === null || _lists$imageType === void 0 ? void 0 : (_lists$imageType$find = _lists$imageType.find(function (f) {
          return f.id === +(activeImage === null || activeImage === void 0 ? void 0 : activeImage.image_type);
        })) === null || _lists$imageType$find === void 0 ? void 0 : _lists$imageType$find.name) || "-"
      })]
    }), shotThd && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles2.Container, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
        headerType: "table-row-text",
        text: "Tipo de imagen THD"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
        headerType: "table-row-text gray-table-row",
        text: (lists === null || lists === void 0 ? void 0 : (_lists$imageShotType = lists.imageShotType) === null || _lists$imageShotType === void 0 ? void 0 : (_lists$imageShotType$ = _lists$imageShotType.find(function (f) {
          return f.id === +(activeImage === null || activeImage === void 0 ? void 0 : activeImage.image_shot_type);
        })) === null || _lists$imageShotType$ === void 0 ? void 0 : _lists$imageShotType$.type_shot) || "-"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles2.Container, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
        headerType: "table-row-text",
        text: "Formato"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
        headerType: "table-row-text",
        text: (activeImage === null || activeImage === void 0 ? void 0 : activeImage.ext) || "-"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles2.Container, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
        headerType: "table-row-text",
        text: "Tama\xF1o de imagen"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
        headerType: "table-row-text",
        text: activeImage !== null && activeImage !== void 0 && activeImage.width && activeImage.height ? "".concat(activeImage === null || activeImage === void 0 ? void 0 : activeImage.width, "x").concat(activeImage === null || activeImage === void 0 ? void 0 : activeImage.height, "px") : "-"
      })]
    }), retailerSelected && (lists === null || lists === void 0 ? void 0 : lists.attrForImgs) && (lists === null || lists === void 0 ? void 0 : (_lists$attrForImgs = lists.attrForImgs) === null || _lists$attrForImgs === void 0 ? void 0 : (_lists$attrForImgs$ge = _lists$attrForImgs.general) === null || _lists$attrForImgs$ge === void 0 ? void 0 : _lists$attrForImgs$ge.map(function (attr, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles2.Container, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
          headerType: "table-row-text",
          text: (attr === null || attr === void 0 ? void 0 : attr.name) || "-"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LabelToInput.default, {
          width: "100px",
          defaultValue: attr === null || attr === void 0 ? void 0 : attr.value,
          onChange: function onChange(e) {
            setImages({
              action: "changeAttrValue",
              value: e.target.value || "-",
              id: attr.id
            });
          }
        })]
      }, "row-" + index + "-" + (attr === null || attr === void 0 ? void 0 : attr.name));
    }))]
  });
};

exports.ImageDataTable = ImageDataTable;